import { render, staticRenderFns } from "./SurgeryDetails.vue?vue&type=template&id=33789509&scoped=true"
import script from "./SurgeryDetails.vue?vue&type=script&lang=js"
export * from "./SurgeryDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33789509",
  null
  
)

export default component.exports